var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/autosuggest_account_input.tsx";
const _excluded = ["onChange", "onSelected", "value", "limit"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { OrderedSet as ImmutableOrderedSet } from 'immutable';
import throttle from 'lodash/throttle';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { accountSearch } from 'soapbox/actions/accounts';
import AutosuggestInput from 'soapbox/components/autosuggest_input';
import { useAppDispatch } from 'soapbox/hooks';
const noOp = () => {};
const AutosuggestAccountInput = _ref => {
  let {
      onChange,
      onSelected,
      value = '',
      limit = 4
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const dispatch = useAppDispatch();
  const [accountIds, setAccountIds] = useState(ImmutableOrderedSet());
  const controller = useRef(new AbortController());
  const refreshCancelToken = () => {
    controller.current.abort();
    controller.current = new AbortController();
  };
  const clearResults = () => {
    setAccountIds(ImmutableOrderedSet());
  };
  const handleAccountSearch = useCallback(throttle(q => {
    const params = {
      q,
      limit,
      resolve: false
    };
    dispatch(accountSearch(params, controller.current.signal)).then(accounts => {
      const accountIds = accounts.map(account => account.id);
      setAccountIds(ImmutableOrderedSet(accountIds));
    }).catch(noOp);
  }, 900, {
    leading: true,
    trailing: true
  }), [limit]);
  const handleChange = e => {
    refreshCancelToken();
    handleAccountSearch(e.target.value);
    onChange(e);
  };
  const handleSelected = (_tokenStart, _lastToken, suggestion) => {
    if (typeof suggestion === 'string' && suggestion[0] !== '#') {
      onSelected(suggestion);
    }
  };
  useEffect(() => {
    if (value === '') {
      clearResults();
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(AutosuggestInput, _extends({
    value: value,
    onChange: handleChange,
    suggestions: accountIds.toList(),
    onSuggestionsFetchRequested: noOp,
    onSuggestionsClearRequested: noOp,
    onSuggestionSelected: handleSelected,
    searchTokens: []
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 5
    }
  }));
};
export default AutosuggestAccountInput;